import React from 'react';
//import FileUploader from "react-firebase-file-uploader";
import { withFirebase } from '../Firebase';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import * as firebase from 'firebase/app';
import FileUploader from 'react-firebase-file-uploader';

import {
    getStorage,
    ref,
    uploadBytes,
    list,
    getDownloadURL
} from 'firebase/storage';

class AddToStorage extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            filenames: [],
            isUploading: false,
            uploadProgress: 0
        };
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleImageAsFile = (e) => {
        const file = e.target.files[0];
        const storage = getStorage();
        const storageRef = ref(storage, 'SliderImages/' + file.name);

        uploadBytes(storageRef, file).then((snapshot) => {
            if (this._isMounted) {
                this.setState((oldState) => ({
                    filenames: [...oldState.filenames, file.name],
                    uploadProgress: 100,
                    isUploading: false
                }));
            }

            this.props.closeTableOnUpload();
        });
    };

    render() {
        const storage = getStorage();
        const listRef = ref(storage, 'SliderImages');

        return (
            <Tooltip title="Upload Images">
                <IconButton aria-label="upload">
                    <label>
                        <CloudUploadIcon />
                        <input
                            type="file"
                            hidden
                            onChange={this.handleImageAsFile}
                        />
                    </label>
                </IconButton>
            </Tooltip>
        );
    }
}

export default withFirebase(AddToStorage);
